<template>
  <div class="download">
    <Nav></Nav>
    <div class="download-content">
      <div class="down_load">
        <div class="down_item">
          <img
            class="qrcode"
            :src="'https://online-lz.oss-accelerate.aliyuncs.com/apk/iosUploadQrcode/SL-QR.jpeg?Timestamp=' + dataTime"
            alt=""
          />
          <div class="download_item">
            <img src="https://online-lz.oss-accelerate.aliyuncs.com/pc-imag/icon.png" alt="" srcset="">
            神龙直播
          </div>
        </div>
        <div class="down_item">
          <img class="qrcode" :src="'https://oss.ansongqiubo.com/apk/iosUploadQrcode/iosQRcode.png?Timestamp='+dataTime" alt="" />
          <div class="download_item">
            <img src="https://online-lz.oss-accelerate.aliyuncs.com/pc-imag/favicon.ico" alt="" srcset="">
            龙珠直播
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "../component/Nav.vue";
// import { initNIMApi } from '@/js_sdk/wysocket.js'
export default {
  data() {
    return {
      dataTime:new Date().getTime()
    };
  },
  components: {
    Nav,
  },
   created() {
  },
  methods:{
    navHelps(){
        console.log('%c [ 帮助 ]: ', 'color: #bf2c9f; background: pink; font-size: 13px;', '帮助')
        const neww = this.$router.resolve({path:'/helpDown', query: {rid:3,infoId:0,valId:1}})
        window.open(neww.href, "_self");
    }
  }
};
</script>

<style lang='scss' scope>
  @media screen and (min-width:500px) {
      .down_load {
          padding-right: 0% !important;
          /* background-color: #550000; */
          .down_item:last-child{
            margin-right: 0 !important;
          }
      }
  }
  @media screen and (min-width:1000px) {
      .down_load {
          padding-right: 2% !important;
          /* background-color: #550000; */
          .down_item:last-child{
            margin-right: 0 !important;
          }
      }
  }
  @media screen and (min-width:1200px) {
      .down_load {
          padding-right:6% !important;
          /* background-color: #721EDC; */
      }
  }
  @media screen and (min-width:1300px) {
      .down_load {
          padding-right:7% !important;
          /* background-color: #721EDC; */
          .down_item:last-child{
            margin-right: 0 !important;
          }
      }
  }
  @media screen and (min-width:1500px) {
      .down_load {
          padding-right: 10% !important;
          /* background-color: #ff00ff; */
      }
  }
  @media screen and (min-width:1600px) {
      .down_load {
          padding-right: 16% !important;
          /* background-color: #D8D8D8; */
      }
  }
  @media screen and (min-width:1800px) {
      .down_load {
          padding-right: 20% !important;
          /* background-color: #D8D8D8; */
      }
  }
.down_load {
  display: flex;
  position: absolute;
  bottom:14vh;
  left: 0;
  right: 0;
  width: 100%;
  box-sizing: border-box;
  /* border: 1px solid red; */
  justify-content: flex-end;
  padding-right: 20%;
  .down_item {
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-right:80px;

    .download_item{
      width: 200px;
      height: 50px;
      border-radius: 25px;
      border: 1px solid #721EDC;
      display: flex;
      justify-content: center;
      align-items: center;
      img{
        margin:0 4px;
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }
    }
    .title {
      width: 144px;
      height: 44px;
    }
    .helps{
      margin-top: 10px;
      width: 201px;
      height: 75px;
      border-radius: 12px;
    }
    .qrcode {
      width: 200px;
      height: 200px;
      background: #D8D8D8;
      border-radius: 6px;
      border: 1px solid #979797;
      margin-bottom: 20px;
    }
  }
  .down_item:last-child{
    align-items: flex-start !important;
  }
}
.download {
  width: 100vw;
  height: 100vh;
  background-image: url(https://oss.ansongqiubo.com/assets/person/downloads.png);
  position: relative;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  float: left;
}
.download-content {
  width: 80%;
  height: 80%;
  position: absolute;
  top: calc(50% - 80% / 2);
  left: calc(50% - 80% / 2);
  display: flex;
  position: relative;
}
.download-content-top {
  margin-top: 20px;
  width: 50%;
  height: calc(100% - 20px);
  box-sizing: border-box;
  padding-top: 30px;
}
.download-content-bottom {
  display: flex;
  margin-top: 20px;
  color: white;
  width: calc(50% - 20px);
  height: calc(100% - 20px);
  margin-left: 20px;
}
.download-content-bottom-content {
  width: 100%;
  height: 100%;
}
/* .download-content-bottom-left{

}
.download-content-bottom-right{

} */
</style>



// WEBPACK FOOTER //
// src/component/Download.vue